import script from "./ShipToContact.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipToContact.vue?vue&type=script&setup=true&lang=js"

import "./ShipToContact.vue?vue&type=style&index=0&id=1123e338&lang=scss"

const __exports__ = script;

export default __exports__